import LinkGroupDetail from "../../Components/LinkGroupDetail/LinkGroupDetail";
import LinkGetter from "../../Components/LinkGetter/LinkGetter";
import "../../Styles/App.css";

function LinkListPage() {
  return (
    <>
      <LinkGroupDetail />

      <LinkGetter />
    </>
  );
}

export default LinkListPage;
